import React from 'react';
import { CreateBudgetActions } from './CreateBudgetActions';
import { useNavigate } from 'react-router-dom';

export const EmptyBudgetState: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = (budgetId: string) => {
    navigate(`/budgets/${budgetId}`);
  };

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-white p-12 text-center dark:border-gray-600 dark:bg-gray-800">
      <h3 className="mb-2 text-sm font-medium text-gray-900 dark:text-white">Aucun budget</h3>
      <p className="mb-4 text-sm text-gray-500 dark:text-gray-400">
        Commencez par créer un nouveau budget ou importez un fichier CSV.
      </p>
      <CreateBudgetActions showText={false} spacing="space-x-2" onSuccess={handleSuccess} />
    </div>
  );
};
